
<div class="container">
   
    <div class="half-container">
    

        <div>
            <div class="headerBackBtn" routerLink="/ai-setting-camera">
                <img src="/assets/images/controlTowers/icon_back_blue.svg" height="15" width="15" alt="Imagen">
                <p class="titleback">{{"BACK" | translate}}</p>
            </div>
            <p class="title">{{"CONFIG_ALERT_SETTING_TITLE" | translate}}</p>
       
        </div>
        
    </div>
    <div class="half-container">
        <div class="headerCreateBtn" (click)="openDialogCreate()">
            
            <p class="titleback">+ {{"CREATE_ALERT" | translate}}</p>
        </div>
    </div>
</div>

<div>
    <neoris-grid  [ColumnsConfiguration]="gridColumnsConfigurationes" [Data]="arrayData"  [ShowChecks]="false"  [GridTitle]="'SUBTITLE_ALERTS_SETTING' | translate" (cellClickEvent)="cellClick($event)"></neoris-grid>
</div>